<div class="row">
<button class="ml-auto" mat-icon-button aria-label="Close variables." (click)="dismiss()">
  <mat-icon>close</mat-icon>
</button>
</div>
<div class="row">
  <div class="col-md-6">
    <mat-list>
      <mat-list-item> <b>New Release Variables:</b> </mat-list-item>
      <mat-list-item *ngFor="let release of releaseVariableKeys"> {{release}} </mat-list-item>
    </mat-list>
  </div>
  <div class="col-md-6">
    <mat-list>
      <mat-list-item> <b>New License Variables:</b> </mat-list-item>
      <mat-list-item *ngFor="let release of licenseVariableKeys"> {{release}} </mat-list-item>
    </mat-list>
  </div>
</div>